module.exports = __webpack_public_path__ + "static/media/ResetPasswordBackgroundMobile.eef54e8d.jpg";